import { toDisplayString as _toDisplayString, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-467530de")

_pushScopeId("data-v-467530de")
const _hoisted_1 = { class: "index" }
const _hoisted_2 = { class: "info" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("div", {
    class: "item",
    onMouseover: _cache[2] || (_cache[2] = $event => (_ctx.play($event))),
    onMouseleave: _cache[3] || (_cache[3] = $event => (_ctx.stop($event)))
  }, [
    _createVNode("span", _hoisted_1, _toDisplayString(_ctx.id), 1 /* TEXT */),
    _withDirectives(_createVNode("img", {
      src: `https://cdn.alt-mp.com/particles/${_ctx.id}.jpg`,
      loading: "lazy"
    }, null, 8 /* PROPS */, ["src"]), [
      [_vShow, !_ctx.isPlaying.value]
    ]),
    _withDirectives(_createVNode("video", {
      ref: "video",
      src: `https://cdn.alt-mp.com/particles/${_ctx.id}.mp4`,
      preload: "none",
      muted: "",
      loop: "",
      loading: "lazy"
    }, null, 8 /* PROPS */, ["src"]), [
      [_vShow, _ctx.isPlaying.value]
    ]),
    _createVNode("div", _hoisted_2, [
      _createVNode("input", {
        type: "text",
        value: `${_ctx.dict}:${_ctx.asset}`,
        readonly: ""
      }, null, 8 /* PROPS */, ["value"]),
      _createVNode("button", {
        class: "copy",
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.copy(`${_ctx.dict}:${_ctx.asset}`)))
      }, "Copy")
    ])
  ], 32 /* HYDRATE_EVENTS */))
})